"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerPortalCustomerContactUpdate = exports.CustomerPortalCustomer = void 0;
const typebox_1 = require("@sinclair/typebox");
const base_customer_1 = require("./base-customer");
const base_customer_contact_1 = require("./base-customer-contact");
exports.CustomerPortalCustomer = typebox_1.Type.Intersect([
    typebox_1.Type.Pick(base_customer_1.BaseCustomer, [
        'id',
        'haulerID',
        'active',
        'customerNumber',
        'billingAddress',
        'companyName',
        'contacts',
        'serviceLocations',
        'stripeID',
        'taxExempt',
        'displayName',
        'accountCredit',
        'accountManagerID',
        'accountManagerName',
        'accountRepID',
        'accountRepName',
        'documents',
        'allowWaysteDashboardAccess',
        'accessToken',
        'paymentTerm',
        'paymentMethod',
        'invoicePdfDisplayOptions',
        'allowedPaymentMethod',
        'accountManager',
        'accountExecutive',
    ]),
    typebox_1.Type.Object({
        paymentSources: typebox_1.Type.Array(typebox_1.Type.Object({
            id: typebox_1.Type.String(),
            brand: typebox_1.Type.String(),
            last4: typebox_1.Type.String(),
            expMonth: typebox_1.Type.Number(),
            expYear: typebox_1.Type.Number(),
            default: typebox_1.Type.Boolean(),
        })),
    }),
]);
exports.CustomerPortalCustomerContactUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Pick(base_customer_1.BaseCustomer, ['companyName', 'billingAddress']),
    typebox_1.Type.Object({
        contact: typebox_1.Type.Partial(typebox_1.Type.Pick(base_customer_contact_1.BaseCustomerContact, [
            'email',
            'firstName',
            'lastName',
            'phoneNumber',
            'sendBillingEmails',
            'sendDispatchEmails',
        ])),
    }),
]));
//# sourceMappingURL=customer-portal.js.map